import { connect } from 'react-redux';

import {
  appModalOpen,
  appModalClose,
} from 'actions/app';

import {
  projectSystemDefinitionFind,
  projectSystemDefinitionFindProducts,
  projectSystemDefinitionPatchProduct,
  projectSystemDefinitionDeleteProduct,
  projectSystemDefinitionUpdateControls,
  projectSystemDefinitionUpdateHydraulics,
} from 'actions/project-system';

import {
  projectUpdatePrice,
  projectUpdate,
  projectGetOriginalSystem,
} from 'actions/projects';

import {
  projectSystemDefinitionCreateNote,
  projectSystemDefinitionPatchNote,
  projectSystemDefinitionDeleteNote,
} from 'actions/project-system-notes';

import View from './';

const mapStateToProps = (state) => {
  const { app, projects, intl } = state;

  return { app, projects, intl };
};

const mapDispatchToProps = (dispatch) => {
  return {
    appModalOpen(payload) {
      return dispatch(appModalOpen(payload));
    },
    appModalClose(payload) {
      return dispatch(appModalClose(payload));
    },
    projectSystemDefinitionFind(id) {
      return dispatch(projectSystemDefinitionFind(id));
    },
    projectSystemDefinitionFindProducts(id) {
      return dispatch(projectSystemDefinitionFindProducts(id));
    },
    projectSystemDefinitionPatch(projectId, productType, payload) {
      return dispatch(projectSystemDefinitionPatchProduct(projectId, productType, payload));
    },
    projectSystemDefinitionDeleteProduct(projectId, productType) {
      return dispatch(projectSystemDefinitionDeleteProduct(projectId, productType));
    },
    projectSystemDefinitionCreateNote(note, projectId) {
      return dispatch(projectSystemDefinitionCreateNote(note, projectId));
    },
    projectSystemDefinitionPatchNote(note, projectId) {
      return dispatch(projectSystemDefinitionPatchNote(note, projectId));
    },
    projectSystemDefinitionDeleteNote(note, projectId) {
      return dispatch(projectSystemDefinitionDeleteNote(note, projectId));
    },
    projectSystemDefinitionUpdateControls(projectId, payload) {
      return dispatch(projectSystemDefinitionUpdateControls(projectId, payload));
    },
    projectSystemDefinitionUpdateHydraulics(projectId, payload) {
      return dispatch(projectSystemDefinitionUpdateHydraulics(projectId, payload));
    },
    projectUpdatePrice(projectId, price) {
      return dispatch(projectUpdatePrice(projectId, price));
    },
    projectUpdate(projectId, payload) {
      return dispatch(projectUpdate(projectId, payload));
    },
    projectGetOriginalSystem(projectId) {
      return dispatch(projectGetOriginalSystem(projectId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/container.js